/**
 * MetricCard — top-of-dashboard KPI tile.
 * value=null renders the "pending backend" dash instead of a fake number.
 */
import React from "react";
import { ArrowUpRight, ArrowDownRight } from "lucide-react";

const TONE_RING = {
  default: "",
  success: "ring-1 ring-success/20",
  warning: "ring-1 ring-warning/20",
  danger: "ring-1 ring-danger/20",
};

const TONE_ICON = {
  default: "text-glow-light bg-glow-light/10",
  success: "text-success bg-success/10",
  warning: "text-warning bg-warning/10",
  danger: "text-danger bg-danger/10",
};

const MetricCard = ({ label, value, helper, icon: Icon, trend, tone = "default", loading = false }) => {
  return (
    <div className={`card-celestial rounded-2xl p-5 flex flex-col gap-3 ${TONE_RING[tone] || ""}`}>
      <div className="flex items-center justify-between">
        <span className="text-xs font-medium text-celestial-muted uppercase tracking-wide">{label}</span>
        {Icon && (
          <span className={`w-7 h-7 rounded-lg flex items-center justify-center ${TONE_ICON[tone] || TONE_ICON.default}`}>
            <Icon className="w-3.5 h-3.5" />
          </span>
        )}
      </div>
      {loading ? (
        <div className="h-8 w-20 rounded-md bg-surface/60 animate-pulse" />
      ) : (
        <div className="text-2xl font-display font-bold text-celestial-text">
          {value === null || value === undefined ? "—" : value}
        </div>
      )}
      {(helper || typeof trend === "number") && (
        <div className="flex items-center gap-1.5 text-xs">
          {typeof trend === "number" && trend !== 0 && (
            <span className={`flex items-center gap-0.5 ${trend > 0 ? "text-success" : "text-danger"}`}>
              {trend > 0 ? <ArrowUpRight className="w-3 h-3" /> : <ArrowDownRight className="w-3 h-3" />}
              {Math.abs(trend)}%
            </span>
          )}
          {helper && <span className="text-celestial-muted/70">{helper}</span>}
        </div>
      )}
    </div>
  );
};

export default MetricCard;
